module.exports = __webpack_public_path__ + "static/media/cheque.eaa5f106.webp";